import { FC } from "react";

type Props = {
  title: string;
  icon: FC<{ className?: string }>;
}

// Shown next to step 1's own header once it's collapsed, so the choice
// stays visible without needing to re-expand it.
const SelectedQuizTypeBadge:FC<Props> = ({ title, icon: Icon }) => (
  <span className="inline-flex items-center gap-2 text-xs text-gray-300 bg-[#2a2a2e] border border-gray-700 rounded-full px-3 py-1 whitespace-nowrap shrink-0 max-w-full overflow-hidden">
    <Icon className="w-3.5 h-3.5 text-orange-500 shrink-0" />
    <span className="truncate">{title}</span>
  </span>
);

export default SelectedQuizTypeBadge;
